import { Component, Input, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/extensions/services/global.service';

@Component({
  selector: 'admin-user-card-view',
  templateUrl: './admin-user-card-view.component.html',
  styleUrl: './admin-user-card-view.component.scss',
  standalone: false,
})
export class AdminUserCardViewComponent {
  @Input() users: app.models.AdminUsersListModel[];
  @Input() props: app.models.DynamicPropsDictionary;

  @Input() deleteUser: any;
  @Input() changeUserStatus: any;
  @Input() redirectUserDetails: any;
  @Input() redirectUserRights: any;

  myUserId;

  public constructor(private _globalService: GlobalService) {
    this.myUserId = this._globalService.user.userId;
  }
}
